import { PRELOAD_WIDGET } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessagePreloadWidget(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: PRELOAD_WIDGET,
      data
    });
  }
}